import { isNative } from "./capacitor";

// حفظ ملف على جهاز المستخدم وإرجاع مكان الحفظ ليُعرض له بوضوح.
const toBase64 = (blob) =>
  new Promise((resolve, reject) => {
    const reader = new FileReader();
    reader.onload = () => resolve(String(reader.result).split(",")[1]);
    reader.onerror = reject;
    reader.readAsDataURL(blob);
  });

const saveWeb = (blob, filename) => {
  const url = URL.createObjectURL(blob);
  const link = document.createElement("a");
  link.href = url;
  link.download = filename;
  document.body.appendChild(link);
  link.click();
  link.remove();
  setTimeout(() => URL.revokeObjectURL(url), 30000);
  return { place: "downloads", filename };
};

const saveNative = async (blob, filename) => {
  const { Filesystem, Directory } = await import("@capacitor/filesystem");
  const { Share } = await import("@capacitor/share");
  const { uri } = await Filesystem.writeFile({
    path: filename,
    data: await toBase64(blob),
    directory: Directory.Documents,
    recursive: true,
  });
  try {
    await Share.share({ title: filename, files: [uri] });
  } catch {
    // أُغلقت نافذة المشاركة: الملف محفوظ أصلاً داخل «الملفات»
  }
  return { place: "files", filename, uri };
};

export const saveBlob = async (blob, filename) =>
  isNative() ? saveNative(blob, filename) : saveWeb(blob, filename);

export const backupFilename = (company, at) => {
  const name = String(company || "company")
    .replace(/[^\p{L}\p{N} _-]/gu, "-")
    .trim()
    .replace(/\s+/g, "-")
    .slice(0, 40);
  return `helcoo-${name}-${String(at || "").slice(0, 10)}.zip`;
};
